import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DateRangeDto} from '../../../shared/dto/DateRangeDto';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ReportService} from '../../../shared/service/report.service';
import {MatTableDataSource} from '@angular/material/table';
import {SearchRequestModel} from '../../../shared/dto/search-request.model';
import {PaymentDetailsReportDto} from '../../../shared/dto/PaymentDetailsReportDto';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import swal, {default as Swal} from 'sweetalert2';

@Component({
  selector: 'app-payment-detail',
  templateUrl: './payment-detail.component.html',
  styleUrls: ['./payment-detail.component.scss']
})
export class PaymentDetailComponent implements OnInit {

  public requestForm: FormGroup;
  public paymentDetailsReportDto:PaymentDetailsReportDto[]=[];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  displayedColumns: string[] = ['refNumber', 'dateAndTime', 'username','amount', 'reason'];
  public printExcelsheet=false;

  constructor(private spinnerService: NgxUiLoaderService, private reportService: ReportService) { }

    ngOnInit() {
    this.requestForm = new FormGroup({
      dateTimeRange: new FormControl(null)
    });
      this.printExcelsheet=true;
  }

  onSubmitSearch(form: FormGroup){
    const dateRange =new DateRangeDto();
    dateRange.date=(form.value.dateTimeRange);
    this.loadSearchResult(dateRange);

  }

  loadSearchResult(dateRange: DateRangeDto ):void{

    this.spinnerService.start();
    this.reportService.searchRequestData(dateRange).subscribe(
      (data: PaymentDetailsReportDto[]) => {
        this.paymentDetailsReportDto = data;
        this.dataSource = new MatTableDataSource(this.paymentDetailsReportDto);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.printExcelsheet=false;

        if (data.length === 0)
          swal.fire('Sorry!', 'No data found', 'info');
      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.paymentDetailsReportDto == null ) {
          swal.fire('Sorry', 'No result found.', 'error');
        //  this.loadAllRequests();
        } else {
          // this.searcRequestService.clearRequestSearchDetails();
          // this.searcRequestService.setRequestSearchDetails(
          //
          // );
        }
      }

    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onClickReset() {
    this.requestForm.reset({
      dateTimeRange: [],
    });
    this.printExcelsheet=true;
   // this.loadAllRequests();
  }

  printExcel(form: FormGroup){
    const dateRange =new DateRangeDto();
    dateRange.date=(form.value.dateTimeRange);

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to print the excel?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.reportService.printExcelReport(dateRange);
      } else {
      }
    });

  }

  exportAsPDF(){
    this.spinnerService.start();
    this.reportService.exportAsPDF(this.paymentDetailsReportDto).subscribe(
      (data:any) =>{
        console.log("This Data " + data);
        const file = new Blob([data], {type:'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank");
      }, error => {
        this.spinnerService.stop();
        console.log(error);
      }
    );
    this.spinnerService.stop();
  }

  exportAsExcel() {
    this.spinnerService.start();
    this.reportService.exportAsExcel(this.paymentDetailsReportDto).subscribe(
      (data:any) =>{
        console.log("This Data " + data);
        const file = new Blob([data], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank");
      }, error => {
        this.spinnerService.stop();
        console.log(error);
      }
    );
    this.spinnerService.stop();
  }



  }

